(function () {
    'use strict';

    realmCommerceApp.controller("CartPreviewController", CartPreviewController);

    /*@ngInject*/
    function CartPreviewController($uibModal, cartService, customerService) {

        var vm = this;
        vm.getCartPreviewItems = getCartPreviewItems;
        vm.getItems = getItems;
        vm.getCart = getCart;
        vm.getCartPreview = getCartPreview;
        vm.promptRemoveCartItem = promptRemoveCartItem;

        activate();

        function activate() {
        }

        function getCustomer() {
            return customerService.getCustomer();
        }

        function getCart() {
            return cartService.getCart();
        }

        function getCartPreview() {
            return cartService.getCartPreview();
        }

        function getItems() {
            if (typeof cartService.getCart().items != 'undefined') {
                return cartService.getCart().items;
            }
        }

        function getCartPreviewItems() {
            if (typeof cartService.getCartPreview().items != 'undefined') {
                return cartService.getCartPreview().items;
            }
        }

        function promptRemoveCartItem(item) {
            $uibModal.open({
                template: require('../layout/modal/removeItem.cart.html'),
                controller: 'CartItemsController',
                controllerAs: 'vm',
                resolve: {
                    cartItemModel: () => item
                }
            });

        }

    }
})();


// WEBPACK FOOTER //
// ./static/js/app/cart/cart.preview.controller.js